import { ReactNode, useEffect } from "react";
import { createPortal } from "react-dom";

export type DocumentPreviewDialogProps = {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
};

export function DocumentPreviewDialog({ open, onClose, children }: DocumentPreviewDialogProps) {
  useEffect(() => {
    if (open && !document.body.classList.contains("overflow-hidden")) {
      document.body.classList.add("overflow-hidden");
      return () => document.body.classList.remove("overflow-hidden");
    }
    
    return () => null;
  }, [open]);

  if (!open) return null;

  return createPortal(
    <div
      className="fixed inset-0 bg-[rgba(0,_0,_0,_0.5)] z-[1000] overflow-auto"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="fixed top-4 left-4 md:left-auto bottom-4 md:bottom-auto md:top-1/2 right-4 md:right-1/2 md:translate-x-[50%] md:-translate-y-[50%] bg-transparent z-[1001] rounded-3xl md:max-h-[90vh] overflow-auto w-auto md:w-[99%] h-auto"
      >
        <div className="p-4 flex justify-center items-center">
          <p className="m-0 grow text-center text-2xl font-bold"></p>
          <button className="text-xl text-white" onClick={onClose}>
            <i className="fa fa-close text-white"></i>
          </button>
        </div>
        <div className="w-full h-full overflow-y-auto">
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
}
